/*eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Accordion } from 'react-bootstrap';
import { AccordionDownArrow, AccordionUpArrow } from '../EnrollmentIconsSvg';
import LifeEventOption from '../life-event-options/LifeEventOptions';
import GenericMessage from 'src/Components/GenericMessage/GenericMessage';
import { useNavigate } from 'react-router-dom';
import { axiosInstance } from '../../../../../api/axios';
import APIEndpoints from '../../../../api/APIEndpoints';
import { HttpSuccessCodes } from '../../../../errorhandling/HttpErrorCodes';
import Skeleton from '../../../../components/common/skeleton';
import { ToastContainer, toast } from 'react-toastify';
import ToastMessage from '../../../common/ToastMessage';
import CustomClientError from '../../../../errorhandling/CustomClientError';
import MasterPermissions from '../../../../api/MasterPermissions';
import '../../enrollment.scss';

const ChangeYourCoverge = () => {
  const navigate = useNavigate();
  const [activeId, setActiveId] = useState(0);
  const [enrollmentCoverageFlows, setEollmentCoverageFlows] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isServerError, setIsServerError] = useState(false);
  const [enrollmentConfigFound, setEnrollmentConfigFound] = useState(true);
  console.log(
    'enrollmentCoverageFlows >>>>>>>>>>>>>>>>>>>   ',
    enrollmentCoverageFlows,
  );
  const changeYourCoverageDetailsKeys = Object.keys(enrollmentCoverageFlows);
  const toggleActive = (id) => {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  };

  const navHandler = (
    flowName,
    showEffectiveDate,
    employerApproval,
    insurerApproval,
  ) => {
    navigate('/admin/enrollment-coverage', {
      state: {
        selectedEnrollmentFlow: flowName,
        showEffectiveDate: showEffectiveDate,
        employerApproval: employerApproval,
        insurerApproval: insurerApproval,
      },
    });
  };

  const handleClick = (
    selectedLabel,
    showEffectiveDate,
    employerApproval,
    insurerApproval,
  ) => {
    console.log(
      'handle Click :::::::::::::  ',
      selectedLabel,
      showEffectiveDate,
    );
    if (selectedLabel === 'Add Dependent') {
      navHandler(
        'AddDependent',
        showEffectiveDate,
        employerApproval,
        insurerApproval,
      );
    } else if (selectedLabel === 'Delete Dependent') {
      navHandler(
        'DeleteDependent',
        showEffectiveDate,
        employerApproval,
        insurerApproval,
      );
    } else if (selectedLabel === 'Address change') {
      navHandler(
        'AddressChange',
        showEffectiveDate,
        employerApproval,
        insurerApproval,
      );
    } else {
      console.log('handle Click :::::::::::::  ', selectedLabel);
      //toast.info(<ToastMessage type="info" subTitle="Work in progress" />);
    }
  };

  const setEnrollmentFlowData = async () => {
    setIsServerError(false);
    try {
      const response = await axiosInstance.get(
        APIEndpoints.getAllEnrollmentConfig(),
      );

      //response = EncrptedResp;
      //const enrollmentConfig = response.data;
      if (
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        console.log('Config >>>>>>>>>>>> ', response);
        const tempConfig = {
          'Change of Address': [],
          'Change in Household': [],
          //Others: [],
        };
        const enrollmentConfig = response?.data?.Response?.EnrollmentConfigList;
        //setEnrollmentConfigList(enrollmentConfig);
        if (enrollmentConfig && enrollmentConfig.length > 0) {
          enrollmentConfig.forEach((configList) => {
            if (configList.Jmplabel === 'Change in Address') {
              tempConfig['Change of Address'].push({
                Name: configList.FlowName,
                EffectiveDate: configList.EffectiveDate,
                Description: configList.Description,
                EmployerApproval: configList?.EmployerApproval || false,
                InsurerApproval: configList?.InsurerApproval || false,
              });
            } else if (configList.Jmplabel === 'Change in Household') {
              tempConfig['Change in Household'].push({
                Name: configList.FlowName,
                EffectiveDate: configList.EffectiveDate,
                Description: configList.Description,
                EmployerApproval: configList?.EmployerApproval || false,
                InsurerApproval: configList?.InsurerApproval || false,
              });
            } /*else {
              tempConfig.Others.push({
                Name: configList.FlowName,
                EffectiveDate: configList.EffectiveDate,
                Description: configList.Description,
              });
            }*/
          });
          console.log('tempConfig :::: >>>>>> ', tempConfig);
          if (!MasterPermissions.CheckPermission('Household change Event')) {
            delete tempConfig['Change in Household'];
          }
          if (!MasterPermissions.CheckPermission('Address Change Event')) {
            delete tempConfig['Change of Address'];
          }
          setEollmentCoverageFlows(tempConfig);
        }
        if (enrollmentConfig && enrollmentConfig.length === 0) {
          setEnrollmentConfigFound(false);
        }
        setIsLoading(false);
      } else {
        console.log('Config else >>>>>>>>>>>> ', response);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      setIsServerError(true);
    }
  };

  useEffect(() => {
    setEnrollmentFlowData();
  }, []);
  return (
    <div className="change-coverage-container">
      {isLoading ? (
        <Skeleton count={8} height={25} />
      ) : isServerError ? (
        <CustomClientError
          ErrorHeading="Something went wrong with request!"
          ErrorMessage="Please try again."
        />
      ) : enrollmentConfigFound ? (
        <Row>
          <Col md="12">
            <p className="content-text">
              Some life changes qualify you to update your health coverage
              outside your usual enrollment period.{' '}
            </p>
            <p className="content-text">
              We understand that life is constantly changing, and so are your
              health care needs. That's why we want to make sure you're aware of
              the special circumstances that allow you to update your health
              coverage outside of the usual enrollment period. Certain life
              changes, such as marriage, the birth of a child, relocation to a
              new area, or losing other health coverage, may qualify you for a
              special enrollment period. This ensures that you have the
              flexibility to adapt your health insurance to match your evolving
              situation. We are here to guide you through this process, making
              it seamless and convenient, so you can focus on what matters most
              – your health and well-being.
            </p>
            <p className="content-text">
              Still have questions or not sure if your particular event
              qualifies? Reach our support team
            </p>
            <div>
              <GenericMessage
                wrapperClasses="mt-4 mb-4 msg-txt"
                boldMessage="Please Note:"
                message="We cannot guarantee the change to your plan and the decision will defer to xxxxx ?"
                messageType={'info'}
                showMessage={true}
                hideCloseButton={true}
              />
            </div>
            <p className="content-text">
              To get started, click on the applicable life event below.
            </p>
            <div>
              <Accordion defaultActiveKey={changeYourCoverageDetailsKeys[0]}>
                <Card className="mt-3">
                  {changeYourCoverageDetailsKeys &&
                    changeYourCoverageDetailsKeys.map((coverageType, index) => (
                      <>
                        <Accordion.Toggle
                          as={Card.Header}
                          onClick={() => toggleActive(index)}
                          className="panel-toggle bg-white text-left w-100"
                          eventKey={coverageType}
                          key={index}
                        >
                          <div className="d-flex justify-content-between panel-card-header">
                            <div className="d-flex">
                              <div className="pr-3">
                                <span className="accordion-arrow">
                                  {activeId === index ? (
                                    <AccordionUpArrow className="acc-arrow" />
                                  ) : (
                                    <AccordionDownArrow className="acc-arrow" />
                                  )}
                                </span>
                              </div>
                              <div className="accordion-title">
                                {coverageType}
                              </div>
                            </div>
                          </div>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey={coverageType}>
                          <Card.Body className="p-3">
                            <div className="display-card">
                              {console.log(
                                ':::::::::::::  ',
                                enrollmentCoverageFlows,
                                enrollmentCoverageFlows[coverageType],
                              )}
                              {changeYourCoverageDetailsKeys &&
                                enrollmentCoverageFlows[coverageType] &&
                                enrollmentCoverageFlows[coverageType].map(
                                  (f, idx) => (
                                    <LifeEventOption
                                      lifeEventName={f.Name}
                                      onClickHandler={handleClick}
                                      key={idx}
                                      showEffectiveDate={f.EffectiveDate}
                                      description={f.Description}
                                      employerApproval={f.EmployerApproval}
                                      insurerApproval={f.InsurerApproval}
                                    />
                                  ),
                                )}
                            </div>
                            <p className="content-text pt-4 pb-3">
                              Select an option to continue
                            </p>
                          </Card.Body>
                        </Accordion.Collapse>
                      </>
                    ))}
                </Card>
              </Accordion>
            </div>
          </Col>
        </Row>
      ) : (
        <CustomClientError
          ErrorHeading="No enrollment config found!"
          ErrorMessage="Please check with admin."
        />
      )}
      <ToastContainer
        draggable
        pauseOnHover
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        autoClose={5000}
        position="top-center"
        newestOnTop={false}
        hideProgressBar={false}
        className="toast-wrapper"
      />
    </div>
  );
};

export default ChangeYourCoverge;
